import { useState, useContext } from "react";
import { X } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { API, AuthContext } from "../App";

const GuestUpgradeModal = ({ onClose }) => {
  const { token, login } = useContext(AuthContext);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(
        `${API}/auth/guest/upgrade`,
        { username, email, password },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      login(res.data.access_token, res.data.user);
      toast.success("Account created! All rooms are now unlocked. 🎉");
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not create your account");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[9700] bg-black/50 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="guest-upgrade-modal"
    >
      <div className="retro-window w-full max-w-sm" onClick={(e) => e.stopPropagation()}>
        <div className="retro-title-bar">
          <span>Create Your Free Account</span>
          <button className="retro-button px-2 py-0 text-xs" onClick={onClose} data-testid="guest-upgrade-close">
            <X className="w-3 h-3" />
          </button>
        </div>
        <div className="p-4 bg-[#C0C0C0]">
          <p className="font-arial text-xs text-[#444] mb-3">
            Keep your guest name &amp; chat history — just pick a username and password to unlock <b>all rooms</b>, games, webcams and more.
          </p>
          <form onSubmit={submit} className="space-y-3">
            <div>
              <label className="block font-verdana text-xs mb-1">Username (8-16 letters/numbers):</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="retro-input w-full"
                required
                placeholder="Choose a username"
                data-testid="guest-upgrade-username"
              />
            </div>
            <div>
              <label className="block font-verdana text-xs mb-1">Email:</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="retro-input w-full"
                required
                placeholder="you@example.com"
                data-testid="guest-upgrade-email"
              />
            </div>
            <div>
              <label className="block font-verdana text-xs mb-1">Password (min 8 chars):</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="retro-input w-full"
                required
                data-testid="guest-upgrade-password"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="retro-button w-full py-1.5 bg-[#7B0099] text-white border-[#7B0099] font-bold"
              data-testid="guest-upgrade-submit"
            >
              {loading ? "Creating..." : "Create Account & Unlock Everything"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default GuestUpgradeModal;
